import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import { GetNotificationUnreadCount } from "../../apis/NotificationAPI";
import eventBus from "../../utils/eventBus";

const SidebarLink = styled(Link)`
  display: flex;
  color: #e1e9fc;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  list-style: none;
  height: 60px;
  text-decoration: none;
  font-size: 18px;
`;

const SidebarLabel = styled.span`
  margin-left: 16px;
`;

const DropdownLink = styled(Link)`
  /*background: #414757;*/
  height: 60px;
  padding-left: 2rem;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #f5f5f5;
  font-size: 18px;
  &:hover {
    cursor: pointer;
  }
`;

export const SubMenu = ({ item }) => {
  const [subnav, setSubnav] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);

  const showSubnav = () => setSubnav(!subnav);

  /// for active class
  const location = useLocation();
  const splitLocation = location.pathname;

  async function GetUserNotificationCount() {
    var result = await GetNotificationUnreadCount();
    setNotificationCount(result.data);
  }

  const handleNewNotification = (d) => {
    GetUserNotificationCount();
  };

  useEffect(() => {
    if (item.title === "Notifications") GetUserNotificationCount();
    eventBus.on("notification", handleNewNotification);
    return () => {
      eventBus.remove("notification", handleNewNotification);
    };
  }, []);

  return (
    <>
      <SidebarLink
        className={splitLocation === item.path ? "active" : ""}
        to={item.path}
        onClick={item.subNav && showSubnav}
      >
        <div className="position-relative">
          {item.icon}
          <SidebarLabel>
            {item.title}{" "}
            {item.title === "Notifications" && (
              <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                {notificationCount > 0 ? notificationCount : ""}
              </span>
            )}
          </SidebarLabel>
        </div>
        <div>
          {item.subNav && subnav
            ? item.iconOpened
            : item.subNav
            ? item.iconClosed
            : null}
        </div>
      </SidebarLink>
      {subnav &&
        item.subNav.map((item, index) => {
          return (
            <DropdownLink
              className={splitLocation === item.path ? "active" : ""}
              to={item.path}
              key={index}
            >
              {item.icon}
              <SidebarLabel>{item.title}</SidebarLabel>
            </DropdownLink>
          );
        })}
    </>
  );
};

export default SubMenu;
